export default __webpack_public_path__ + "static/media/guarddestroyer1.d1b2235e.png";